import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { LOGOUT } from '../constants/actions/auth.constants';
import IntegrationService from '../services/common/IntegrationService';
import IIntegration from '../types/integration/IIntegration';

const NAME = 'INTEGRATION';

const getIntegration = createAsyncThunk(
    `${NAME}/getIntegration`,
    IntegrationService.getIntegration,
);

const enableIntegration = createAsyncThunk(
    `${NAME}/enableIntegration`,
    IntegrationService.enableIntegration,
);

type State = {
    data: IIntegration | undefined;
    loading: boolean;
    error: boolean;
};

const initialState: State = {
    data: undefined,
    loading: false,
    error: false,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getIntegration.fulfilled, (state: State, action) => {
            state.data = action.payload.data;
        });

        builder.addCase(enableIntegration.fulfilled, (state: State) => {
            if (state.data) {
                state.data = { ...state.data, enabled: true };
            }
        });

        builder.addCase(LOGOUT, (state) => {
            state.data = undefined;
            state.loading = false;
            state.error = false;
        });

        builder.addMatcher(
            isAnyOf(getIntegration.pending, enableIntegration.pending),
            pending,
        );
        builder.addMatcher(
            isAnyOf(getIntegration.fulfilled, enableIntegration.fulfilled),
            fulfilled,
        );
        builder.addMatcher(
            isAnyOf(getIntegration.rejected, enableIntegration.rejected),
            rejected,
        );

        function fulfilled(state: State) {
            state.loading = false;
            state.error = false;
        }

        function pending(state: State) {
            state.loading = true;
            state.error = false;
        }

        function rejected(state: State) {
            state.loading = false;
            state.error = true;
        }
    },
});

const IntegrationActions = {
    getIntegration,
    enableIntegration,
};

export default IntegrationActions;
export const IntegrationReducer = slice.reducer;
